import MApp from "../../modules/MApp";
import MModal from "../../modules/MModal";
import MRequest from "../../modules/MRequest";
import MDiaryDay from "./MDiaryDay";

export default class MDiaryDaySearch
{
	constructor(el)
	{
		this.el = el;
	}

	getDiaryDay()
	{
		return new MDiaryDay(this.el.closest(".diary-day"));
	}

	getPreloaderElement()
	{
		return this.el.querySelector(".profile-diary-search__preloader");
	}

	showPreloader()
	{
		this.getPreloaderElement()?.removeAttribute("hidden");
	}

	hidePreloader()
	{
		this.getPreloaderElement()?.setAttribute("hidden", "");
	}

	getNoDataElement()
	{
		return this.el.querySelector(".profile-diary-search__no-data");
	}

	showNoData()
	{
		this.getNoDataElement()?.removeAttribute("hidden");
	}

	hideNoData()
	{
		this.getNoDataElement()?.setAttribute("hidden", "");
	}

	getResultsElement()
	{
		return this.el.querySelector(".profile-diary-search__results");
	}

	setResults(results)
	{
		this.getResultsElement().innerHTML = null;
		for (let result of results) {
			this.getResultsElement().innerHTML += result.templates["diary.searchResult"];
		}
		this.showResults();
	}

	showResults()
	{
		this.getResultsElement()?.removeAttribute("hidden");
	}

	hideResults()
	{
		this.getResultsElement()?.setAttribute("hidden", "");
	}

	getTerm()
	{
		return this.el.querySelector(".profile-diary-search__query").value.trim();
	}

	resetTerm()
	{
		this.el.querySelector(".profile-diary-search__query").value = null;
		this.el.dataset.term = null;
	}

	getAddUrl()
	{
		return this.el.dataset.addUrl;
	}

	search(scenario)
	{
		let term = this.getTerm();
		if (!term) {
			return;
		}
		if (scenario == "term" && term == this.el.dataset.term) {
			return;
		}

		this.el.dataset.term = term;

		this.showPreloader();
		this.hideNoData();
		this.hideResults();

		let url = this.el.dataset.searchUrl;

		let data = {
			term: term,
			limit: 50,
			isAvailable: 1,
			isAllowed: 1,
			isDiaryCompatible: 1,
			tagIds: [],
			fields: {
				templates: [
					"diary.searchResult",
				],
			},
		};

		this.el.querySelectorAll("[name=\"tagIds[]\"]:checked").forEach(el => data.tagIds.push(parseInt(el.dataset.tagId)));

		MRequest.post(url, data).then(response => {
			this.setResults(response.data);
			this.hidePreloader();
			if (!response.data.length) {
				this.showNoData();
			}

			MApp.refresh();
		});
	}

	createEntry(diaryDaySearchResult)
	{
		let diaryDay = this.getDiaryDay();

		let url = this.getAddUrl();
		let data = {
			date: this.getDiaryDay().getDate(),
			objectId: diaryDaySearchResult.getObjectId(),
			practicalUnitId: diaryDaySearchResult.getPracticalUnitId(),
			amount: diaryDaySearchResult.getAmount(),
		};

		const preloader = diaryDay.getSection("meals").getPreloderTemplate().getElement();
		preloader.querySelector(".template-title").innerHTML = diaryDaySearchResult.el.dataset.title;
		diaryDay.getSection("meals").el.append(preloader);

		MModal.closeAll();

		MRequest.post(url, data).then(response => {
			diaryDay.getSection("meals").setEntriesHtml(response.data.templates.entries);
			preloader.remove();
			diaryDay.getSidebar().setHtml(response.data.templates.sidebar);
		}).finally(() => {
			MApp.refresh();
		});
	}
}
